import React from 'react';
import './BrowserWindow.css';

const BrowserWindow = ({ children, variant = 'dark', className = '' }) => {
  return (
    <div className={`bw-container bw-${variant} ${className}`}>
      <div className="bw-titlebar">
        <span className="bw-dot bw-dot-red" />
        <span className="bw-dot bw-dot-yellow" />
        <span className="bw-dot bw-dot-green" />
      </div>
      <div className="bw-body">
        {children}
      </div>
    </div>
  );
};

export default BrowserWindow;
